import { render } from "./NewEmailDialog.vue?vue&type=template&id=3b39168d"
import script from "./NewEmailDialog.vue?vue&type=script&lang=js"
export * from "./NewEmailDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__